import { render, staticRenderFns } from "./dropdownSearch.vue?vue&type=template&id=16ff6044&scoped=true&"
import script from "./dropdownSearch.vue?vue&type=script&lang=js&"
export * from "./dropdownSearch.vue?vue&type=script&lang=js&"
import style0 from "./dropdownSearch.vue?vue&type=style&index=0&id=16ff6044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff6044",
  null
  
)

export default component.exports